export default "__VITE_ASSET__c325ec97__"